import { combineReducers, legacy_createStore as createStore } from 'redux';
import productsReducer from './products-reducer';
import contactReducer from './contact-reducer';
import aboutReducer from './about-reducer';
import newsReducer from './news-reducer';
import commentsReducer from './comments-reducer';

let reducers = combineReducers({
  productsPage: productsReducer,
  contactPage: contactReducer,
  aboutPage: aboutReducer,
  newsPage: newsReducer,
  commentsPage: commentsReducer,
});

let store = createStore(reducers);

export default store;
